// extracted by mini-css-extract-plugin
module.exports = {"form":"form-common__form___3jNLS"};